module.exports = __webpack_public_path__ + "static/media/migrante.a8bd7cd4.png";